import { defineRecipe } from "@chakra-ui/react/styled-system";
import { interactiveTransition } from "./_shared";

export default defineRecipe({
  base: {
    fontWeight: "semibold",
    focusVisibleRing: "outside",
    focusRingWidth: "2px",
    ...interactiveTransition,
  },
  variants: {
    variant: {
      outline: {},
      conversationControl: {
        borderRadius: "full",
        color: "colorPalette.fg",
        borderWidth: "1px",
        borderColor: "colorPalette.muted",
        _hover: { bg: "colorPalette.subtle" },
      },
      popoverAction: {
        width: "full",
        justifyContent: "start",
        paddingInline: "5",
        borderRadius: "none",
        fontWeight: "normal",
        color: "colorPalette.fg",
        _hover: { bg: "colorPalette.subtle" },
      },
      // A clickable two-line label inside a List "row": primary text above,
      // secondary text below, left-aligned, no button chrome.
      rowLabel: {
        display: "grid",
        justifyItems: "start",
        textAlign: "start",
        whiteSpace: "normal",
        height: "auto",
        minHeight: "10",
        minWidth: "0",
        paddingInline: "0",
        paddingBlock: "1",
        color: "fg.default",
        bg: "transparent",
        _hover: { textDecoration: "underline" },
      },
    },
  },
  defaultVariants: {
    variant: "outline",
  },
});
